import React from 'react';
import { Outlet } from 'react-router-dom';
import KoachLayoutHeader from './KoachLayoutHeader';
import KoachLayoutMenu from './KoachLayoutMenu';

const KoachLayoutComponent = (props: any) => {
    const { needStandaloneMain, needNoMenu } = props;

    return (
        <>
            {needStandaloneMain ? null : <KoachLayoutHeader />}
            <Outlet />
            {needStandaloneMain ? null : <KoachLayoutMenu needNoMenu={needNoMenu} />}
        </>
    );
};

export default KoachLayoutComponent;